module.exports = __webpack_public_path__ + "media/images/history-icon-95c500557c3429e2e8b64551496a9afe.svg";